<aside class="flex flex-col w-96 shrink-0 gap-4 p-4 overflow-y-auto bg-white rounded text-chathams-blue">
  <div>
    <p class="text-sm text-gray-500">Dados do paciente</p>
    <p class="text-lg font-bold">{{ patientName }}</p>
  </div>

  <p *ngIf="loading" class="text-sm text-gray-500">Carregando dados do paciente...</p>

  <ng-container *ngIf="!loading">
    <!-- Sinais vitais e triagem: clinical-metrics, mesma sessão do totem -->
    <section class="border border-gray-300 rounded shadow-sm">
      <div class="px-4 py-2 font-semibold text-white rounded-t bg-downy">Sinais Vitais</div>

      <div *ngIf="triage; else semTriagem" class="p-4 space-y-2">
        <p class="text-xs text-gray-500">
          Medido em {{ triage.createdAt | date: 'dd/MM/yyyy' }}
          <span *ngIf="!isFromToday(triage.createdAt)" class="font-semibold text-red-500">(não é de hoje)</span>
        </p>
        <div class="grid grid-cols-2 gap-2">
          <p *ngIf="triage.bloodPressure">
            <strong>PA (mmHg):</strong> {{ formatBloodPressure(triage.bloodPressure) }}
          </p>
          <p *ngIf="triage.heartRate"><strong>FC (bpm):</strong> {{ triage.heartRate }}</p>
          <p *ngIf="triage.oxygenSaturation"><strong>SpO₂ (%):</strong> {{ triage.oxygenSaturation }}</p>
          <p *ngIf="triage.weight"><strong>Peso (kg):</strong> {{ triage.weight }}</p>
          <p *ngIf="heightInCm(triage.height) as altura"><strong>Altura (cm):</strong> {{ altura }}</p>
          <p *ngIf="triage.imc"><strong>IMC:</strong> {{ triage.imc | number: '1.0-1' }}</p>
        </div>
      </div>
    </section>

    <section *ngIf="triage" class="border border-gray-300 rounded shadow-sm">
      <div class="px-4 py-2 font-semibold text-white rounded-t bg-downy">Fatores de Risco</div>
      <div class="p-4 space-y-1">
        <p><strong>Sobrepeso:</strong> {{ formatTriageAnswer(triage.overweight) }}</p>
        <p><strong>Fumante há mais de 10 anos:</strong> {{ formatTriageAnswer(triage.smokerForOverTenYears) }}</p>
        <p><strong>Colesterol alto:</strong> {{ formatTriageAnswer(triage.highCholesterol) }}</p>
        <p><strong>Pressão arterial habitual:</strong> {{ formatBloodPressureGroup(triage.hypertension) }}</p>
        <p><strong>Diabetes:</strong> {{ formatTriageAnswer(triage.diabetes) }}</p>
      </div>
    </section>

    <!-- Dr. Olive: último diagnóstico do usuário -->
    <section class="border border-gray-300 rounded shadow-sm">
      <div class="px-4 py-2 font-semibold text-white rounded-t bg-downy">Análise de Sintomas</div>

      <div *ngIf="diagnosis; else semDiagnostico" class="p-4 space-y-3">
        <p class="text-xs text-gray-500">
          Realizada em {{ diagnosis.diagnosedAt | date: 'dd/MM/yyyy HH:mm' : brasiliaOffset }}
          <span *ngIf="!isFromToday(diagnosis.diagnosedAt)" class="font-semibold text-red-500">(não é de hoje)</span>
        </p>

        <p *ngIf="diagnosis.specialist"><strong>Especialista recomendado:</strong> {{ diagnosis.specialist }}</p>

        <div *ngIf="diagnosis.conditions?.length">
          <p class="font-semibold">Hipóteses</p>
          <ul class="space-y-1">
            <li *ngFor="let condition of diagnosis.conditions">
              <strong>{{ condition.probability | number: '1.0-0' }}%</strong> {{ condition.label }}
            </li>
          </ul>
        </div>

        <div *ngIf="diagnosis.symptoms?.length">
          <p class="font-semibold">Evidências</p>
          <ul class="ml-5 list-disc">
            <li *ngFor="let symptom of diagnosis.symptoms">{{ symptom.label }}</li>
          </ul>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template #semDiagnostico>
    <p class="p-4 text-sm text-gray-500">Nenhuma análise de sintomas encontrada para este paciente.</p>
  </ng-template>

  <ng-template #semTriagem>
    <p class="p-4 text-sm text-gray-500">Nenhuma medição encontrada para este paciente.</p>
  </ng-template>
</aside>
